"use client"

import { useEffect } from "react"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error for monitoring
    console.error('Application error:', error)
    
    // Send to analytics if available
    if (typeof window !== 'undefined' && (window as any).va) {
      (window as any).va('event', {
        name: 'error',
        data: {
          message: error.message,
          digest: error.digest,
        }
      })
    }
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-6xl font-bold mb-4">ERROR</h1>
          <div className="w-24 h-px bg-foreground mx-auto mb-6" />
          <p className="text-muted-foreground font-mono text-sm">
            Something went wrong. Please try again.
          </p>
        </div>
        
        <button
          onClick={reset}
          className="px-8 py-3 border border-foreground hover:bg-foreground hover:text-background transition-colors font-mono text-sm tracking-wider"
        >
          TRY AGAIN
        </button>
        
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8 p-4 border border-border text-left">
            <p className="font-mono text-xs text-muted-foreground mb-2">
              Development Error Details:
            </p>
            <pre className="font-mono text-xs text-foreground overflow-auto">
              {error.message}
            </pre>
          </div>
        )}
      </div>
    </div>
  )
}
